import { OfficeMin } from 'types/offices';
import { t } from 'utils/getTranslations';

export const officeInactiveSuffix = (option: Pick<OfficeMin, 'isActive'>) =>
    option.isActive === false ? t('common.inactive-suffix') : null;
